import { BIEventIds } from './event-ids';
import { sendBi } from './send-request';
import { get } from '../../utils/utils';
const catalogIds = {
  default: 0,
  private: 1,
  public: 2,
  // static - unused
  bigstock: 4,
  drive: 5,
  dropbox: 6,
  facebook: 7,
  flickr: 8,
  instagram: 9,
  picasa: 10,
  'private-site': 11,
  'deviant-art': 12,
  dribbble: 13,
  facebookVideo: 14,
  favorites: 15,
  'google-photos': 16,
  recommended: 17,
  shutterstock: 18,
  unsplash: 19,
  vimeoSearch: 20,
  'visitors-uploads': 21,
  'wix-site': 22,
  youtubeSearch: 23
};
export function sendBiError(adapterName, eventName, response, options) {
  const httpCode = response.code || '000';
  const adapterCode = BIEventIds.BIAdaptersIds[adapterName] || '00';
  const requestCode = BIEventIds.BIAdaptersRequestsIds[eventName] || '00';
  const errorDesc = `${adapterName} ${eventName}: ${response.message}`;
  const errorCode = adapterCode + requestCode + httpCode;
  const errorName = `${adapterName}.${eventName}.${httpCode}`; // error code string

  return sendBi('/trg', {
    src: 25,
    evid: 10,
    cat: catalogIds[adapterName] || catalogIds.default,
    // event type
    iss: 1,
    // issue (sub-category)
    sev: BIEventIds.severity.error,
    errc: errorCode || '0000000',
    errn: errorName || '',
    ver: options.version || 'VERSION',
    did: (options.siteId || '').replace('_template_', ''),
    p1: httpCode || '000',
    p2: get(response, 'data.error_code', ''),
    p3: get(response, 'data.error_info.key', ''),
    //p4: '',  // media type
    ts: options.requestTimeMs || '',
    dsc: errorDesc || ''
  });
}